export default "__VITE_ASSET__vBhsr9Cd__"